import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import AppLayout from "@/components/layout/AppLayout";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { ThemeProvider } from "@/context/ThemeContext";
import { ConsultationProvider } from "@/context/ConsultationContext";
import Landing from "@/pages/Landing";
import Demo1Receptionist from "@/pages/Demo1Receptionist";
import Demo2CRM from "@/pages/Demo2CRM";
import Demo3Appointments from "@/pages/Demo3Appointments";
import Demo4Invoice from "@/pages/Demo4Invoice";
import Demo5Inventory from "@/pages/Demo5Inventory";
import Demo6HR from "@/pages/Demo6HR";
import Demo7Analytics from "@/pages/Demo7Analytics";
import ContactPage from "@/pages/ContactPage";
import HelpPage from "@/pages/HelpPage";
import SettingsPage from "@/pages/SettingsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <ConsultationProvider>
            <ScrollToTop />
            <AppLayout>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/demo/receptionist" element={<Demo1Receptionist />} />
                <Route path="/demo/crm" element={<Demo2CRM />} />
                <Route path="/demo/appointments" element={<Demo3Appointments />} />
                <Route path="/demo/invoicing" element={<Demo4Invoice />} />
                <Route path="/demo/inventory" element={<Demo5Inventory />} />
                <Route path="/demo/hr" element={<Demo6HR />} />
                <Route path="/demo/analytics" element={<Demo7Analytics />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Routes>
            </AppLayout>
          </ConsultationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
